import { ElMessage } from 'element-plus'

export const useNotify = {
  Toast(message) {
    ElMessage({
      message,
      type: 'info'
    })
  },

  Success(message) {
    ElMessage({
      message,
      type: 'success'
    })
  },

  Warning(message) {
    ElMessage({
      message,
      type: 'warning'
    })
  },

  Error(message) {
    ElMessage({
      message,
      type: 'error'
    })
  }
}
